import { gql } from '@apollo/client'

export default gql(`
    mutation batchArchiveAssets($batchJobId: ID!) {
        batchArchiveAssets(
            batchJobId: $batchJobId
        ) {
            isArchived
        }
    }`
)
